/*
 * Submission date component
 */
import React from 'react';
import TextField from './text_field.jsx';

export default class AdaliaMESubmissionDate extends TextField {

        static icon(){
            return <i className="fa fa-calendar"></i>;
        }

        static get TYPE() {
            return 'adalia_me_submission_date';
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                label: 'component_title_adalia_me_submission_date',
                placeholder: 'field_default_placeholder',
                description: 'field_default_description',
                help: null,
                unit: null
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                name: 'submission_date',
                required: false,
                cloneable: false,
                reportKey: 'Submission date'
            });
        }
}
